/**
 * Split a stored patient name into the First / Middle / Last boxes.
 *
 * `notes-c.patient_name` is one string, conventionally "Last, First Middle"
 * ("Novelo, Victor"), but plain "First Middle Last" also occurs. AddPatientModal
 * shows three separate required inputs plus a composed "Name (as will appear)",
 * so anything that prefills the composed name has to fill the parts too or the
 * form opens with two red-starred fields empty.
 *
 * This was duplicated verbatim in two places in AddPatientModal and missing from
 * a third (the `initialData` path used by appointment approval), which is
 * exactly the bug it now prevents.
 */
export function splitPatientNameParts(fullName) {
  const text = String(fullName ?? "").trim();
  if (!text) return { firstName: "", middleName: "", lastName: "" };

  if (text.includes(",")) {
    // "Novelo, Victor J" -> last "Novelo", first "Victor", middle "J"
    const [lastPart, firstMiddlePart] = text.split(",").map((s) => s.trim());
    const [first, ...middle] = firstMiddlePart
      ? firstMiddlePart.split(/\s+/).filter(Boolean)
      : [];
    return {
      firstName: first || "",
      middleName: middle.join(" "),
      lastName: lastPart || "",
    };
  }

  // "Victor J Novelo" -> last "Novelo", first "Victor", middle "J".
  // A single word becomes the LAST name, matching how the modal has always
  // treated it — changing that would silently move existing names between
  // fields.
  const parts = text.split(/\s+/).filter(Boolean);
  const lastName = parts.pop() || "";
  const firstName = parts.shift() || "";
  return { firstName, middleName: parts.join(" "), lastName };
}
